<template>
  <div class="app" v-cloak>
    <HeaderComponent></HeaderComponent>
    <authenticator :hide-sign-up="true" :form-fields="formFields">
      <router-view />
    </authenticator>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import '@aws-amplify/ui-vue/styles.css';

import { AppSetup } from '@/views/AppBase'

import HeaderComponent from '@/components/pc/HeaderComponent.vue';
import FooterComponent from '@/components/pc/FooterComponent.vue';

export default defineComponent({
  name: 'PcApp',
  components: {
    HeaderComponent,
    FooterComponent
  },
  setup() {
    return AppSetup();
  }
});
</script>

<style src="@/assets/pc/css/swiper-bundle.css" />
<style src="@/assets/pc/css/style.css" />
<style>
/*
:root {
  --header-h: 100px;
  --header-color: rgb(209, 235, 243);
  --header-bg: #192e5a;
  --header-image: none;
  --search-kw-bg: #ffd;
  --search-kw-border: 1px solid #fff;
  --search-kw-ph: rgba(444, 0.3);
  --search-btn: #f93;
  --search-btn-hover: var(--text-secondary);
  --search-btn-color: rgb(31, 26, 4);
  --kv-bg: #223;
  --fmenu-bg: #192e5a;
  --fmenu-color: rgba(255, 255, 255, 0.8);
  --cr-bg: #05112b;
  --cr-color: rgba(255, 255, 255, 0.8);
  --rank-bg: #95e1ff;
  --rank-hover: #76c6e6;
  --rank-text: rgb(22, 26, 34);
  --current: var(--color03);
}
*/
</style>
<style>
[data-amplify-authenticator] {
  --amplify-components-authenticator-router-background-color: transparent;
  --amplify-components-authenticator-router-box-shadow: none;
  --amplify-components-authenticator-router-border-color: transparent;
  --amplify-components-button-primary-background-color: #000;
  --amplify-components-button-primary-hover-background-color: rgba(0, 0, 0, .7);
  --amplify-components-heading-color: #fff;
  --amplify-components-field-label-color: #fff;
  --amplify-components-button-link-color: #fff;
  --amplify-components-button-link-hover-background-color: rgba(255, 255, 255, .15);
  --amplify-components-button-link-hover-color: #fff;
  margin: 0 auto auto;
}

[data-amplify-authenticator] [data-amplify-container] {
  margin-right: auto;
  margin-left: auto;
}

.amplify-input {
  background-color: #fff;
}

.amplify-field__show-password {
  background-color: #fff;
}
</style>
